import { Box, Button, Link, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

export const RootErrorBoundary: FC = (): JSX.Element => {
  const { t } = useTranslation('common');
  let error = useRouteError() as Error;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Typography variant="inter28" fontWeight={900}>
          {error?.message ? (
            `Error : ${error.message}`
          ) : (
            <> 404 {t('errors.router.notFound.title')}</>
          )}
        </Typography>

        <Typography color="textSecondary" fontWeight={'fontWeightBold'} sx={{ maxWidth: 650 }}>
          {error?.stack ? error.stack : t('errors.router.notFound.description')}
        </Typography>
        {/* <Typography
          color="textSecondary"
          sx={{ lineHeight: 1.5, fontWeight: 'normal', fontSize: 14 }}
        >
          <pre>{error.message || JSON.stringify(error)}</pre>
        </Typography> */}
        <Link
          href="/"
          sx={{
            textDecoration: 'none',
            color: theme => theme.palette.info.main,
          }}
        >
          <Button variant="contained">{t('errors.router.notFound.link')}</Button>
        </Link>
      </Box>
    </Box>
  );
};
